<template>
  <div class="tasks-filters">
    <div class="tasks-filters-container">
      <div>
        <div class="tasks-filters-search"
             v-bind:class="{ 'not-empty': titleSearchFilter[list] !== '', focused: titleSearchFilterFocused }">
          <label class="tasks-filters-title" :for="'titleSearchFilter-' + list">Search task by ID or keyword</label>
          <div class="tasks-filters-search-input">
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="search"
                 class="svg-inline--fa fa-search fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg"
                 viewBox="0 0 512 512">
              <path fill="currentColor" d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0
                  208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9
                  0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128
                  0 70.7-57.2 128-128 128z"></path>
            </svg>
            <input :id="'titleSearchFilter-' + list"
                   type="search"
                   placeholder="Search task"
                   v-bind:value="titleSearchFilter[list]"
                   @input="titleSearchInput($event)"
                   @focus="titleSearchFilterFocused = true"
                   @blur="titleSearchFilterFocused = false">
          </div>
        </div>
        <div class="tasks-filters-chapter">
          <div class="tasks-filters-title">
            Task category
            <button class="tasks-filters-title-counter"
                    v-if="activeFiltersCount('chapter')"
                    @click="clearFilter('chapter')">
              {{ activeFiltersCount('chapter') }}
              <span class="tasks-filters-title-counter-x">
              <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="times" class="svg-inline--fa fa-times fa-w-11"
                   role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512">
                <path fill="currentColor" d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48
                0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28
                12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48
                0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path>
              </svg>
            </span>
            </button>
          </div>
          <div class="tasks-filters-chapter-items">
            <div class="tasks-filters-chapter-item tasks-filters-tooltip-container"
                 role="button"
                 tabindex="0"
                 :aria-label="'Filter by: \'' + chapter.name + '\' chapter'"
                 @click="filterByChapter(chapter)"
                 v-bind:class="{ active: isFilterActive('chapter', chapter.id) }"
                 v-for="chapter in taskChapters">
              <div class="tasks-filters-chapter-item-progress">
                <div class="tasks-filters-chapter-item-image" v-bind:style="{backgroundImage: getChapterBackground(chapter) }"></div>
                <svg class="progress" width="130" height="130" viewBox="0 0 100 100">
                  <circle class="progress_meter" cx="50" cy="50" r="44" stroke-width="5"/>
                  <circle class="progress_value"
                          :class="'filters_progress_value-' + chapter.id"
                          cx="50" cy="50" r="44"
                          v-if="getUserRole !== 'ta' && getUserRole !== 'tu'"
                          stroke-width="5"/>
                </svg>
              </div>
              <div class="tasks-filters-tooltip">
                {{ chapter.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="tasks-filters-assignee">
          <div class="tasks-filters-title">
            Assignee
            <button class="tasks-filters-title-counter"
                    v-if="activeFiltersCount('assignee')"
                    @click="clearFilter('assignee')">
              {{ activeFiltersCount('assignee') }}
              <span class="tasks-filters-title-counter-x">
              <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="times" class="svg-inline--fa fa-times fa-w-11"
                   role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512">
                <path fill="currentColor" d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48
                0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28
                12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48
                0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path>
              </svg>
            </span>
            </button>
          </div>
          <div class="tasks-filters-assignee-items">
            <div class="tasks-filters-assignee-item tasks-filters-tooltip-container"
                 role="button"
                 tabindex="0"
                 :aria-label="'Filter by: \'' + user.label + '\' user'"
                 @click="filterByAssignee(user)"
                 v-bind:class="{ active: isFilterActive('assignee', user.value) }"
                 v-for="user in taskAssignee">
              <div class="tasks-filters-assignee-item-icon">
                <span v-if="user.image" v-bind:style="{ backgroundImage: 'url(\'' + imageBase + user.image + '\')' }"></span>
                <avatar v-else :username="user.label" :size="32" color="#ffffff"></avatar>
              </div>
              <div class="tasks-filters-tooltip">
                {{ user.label }}
              </div>
            </div>
            <div class="tasks-filters-assignee-item unassigned tasks-filters-tooltip-container"
                 role="button"
                 tabindex="0"
                 :aria-label="'Filter by: \'Unassigned\''"
                 @click="filterByAssignee(false)"
                 v-bind:class="{ active: isFilterActive('assignee', 'unassigned') }">
              <div class="tasks-filters-assignee-item-icon">
                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="user-circle"
                     class="svg-inline--fa fa-user-circle fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg"
                     viewBox="0 0 496 512">
                  <path fill="currentColor" d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0
                  88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4
                  55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1
                  7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"></path>
                </svg>
              </div>
              <div class="tasks-filters-tooltip">
                Unassigned
              </div>
            </div>
          </div>
        </div>
        <div class="tasks-filters-status" v-if="list === 'backlog'">
          <div class="tasks-filters-title">
            Status
            <button class="tasks-filters-title-counter"
                    v-if="activeFiltersCount('status')"
                    @click="clearFilter('status')">
              {{ activeFiltersCount('status') }}
              <span class="tasks-filters-title-counter-x">
              <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="times" class="svg-inline--fa fa-times fa-w-11"
                   role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512">
                <path fill="currentColor" d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48
                0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28
                12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48
                0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path>
              </svg>
            </span>
            </button>
          </div>
          <div class="tasks-filters-status-items">
            <div class="tasks-filters-status-item tasks-filters-tooltip-container"
                 role="button"
                 tabindex="0"
                 :aria-label="'Filter by: \'' + status.name + '\' status'"
                 @click="filterByStatus(status)"
                 v-bind:class="[{ active: isFilterActive('status', status.id) }, 'status-' + status.id]"
                 v-for="status in taskStatuses">
              <template v-if="status.id === 1">
                <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="dot-circle"
                     class="svg-inline--fa fa-dot-circle fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <path fill="currentColor" d="M256 56c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200
                0-110.532 89.451-200 200-200m0-48C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0
                168c-44.183 0-80 35.817-80 80s35.817 80 80 80 80-35.817 80-80-35.817-80-80-80z"></path>
                </svg>
              </template>
              <template v-else-if="status.id === 2">
                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="spinner"
                     class="svg-inline--fa fa-spinner fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg"
                     viewBox="0 0 512 512">
                  <path fill="currentColor" d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48
                368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49
                48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49
                48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156
                0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48
                21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"></path>
                </svg>
              </template>
              <template v-else-if="status.id === 3">
                <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="eye"
                     class="svg-inline--fa fa-eye fa-w-18" role="img" xmlns="http://www.w3.org/2000/svg"
                     viewBox="0 0 576 512">
                  <path fill="currentColor" d="M288 144a110.94 110.94 0 0 0-31.24 5 55.4 55.4 0 0 1 7.24 27 56 56 0 0 1-56 56 55.4
                55.4 0 0 1-27-7.24A111.71 111.71 0 1 0 288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48
                241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0
                0-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z"></path>
                </svg>
              </template>
              <template v-else-if="status.id === 4">
                <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="check-circle"
                     class="svg-inline--fa fa-check-circle fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg"
                     viewBox="0 0 512 512">
                  <path fill="currentColor" d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8
                256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532
                89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346
                303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068
                16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"></path>
                </svg>
              </template>
              <span class="status-text">{{ status.counter }}</span>
              <div class="tasks-filters-tooltip">
                {{ status.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <button class="tasks-filters-reset"
                v-if="anyFilters"
                @click="clearAllFilters">
          <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="filter"
               class="svg-inline--fa fa-filter fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg"
               viewBox="0 0 512 512">
            <path fill="currentColor" d="M487.976 0H24.028C2.71 0-8.047 25.866 7.058 40.971L192 225.941V432c0 7.831 3.821 15.17
                10.237 19.662l80 55.98C298.02 518.69 320 507.493 320 487.98V225.941l184.947-184.97C520.021 25.896 509.338 0 487.976 0z"></path>
          </svg>
          <span>Reset filters</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '@/api'
  import { mapGetters } from 'vuex'
  import Avatar from 'vue-avatar'

  export default {
    name: 'tasks-filters',
    props: {
      company: Number,
      list: {
        type: String,
        required: true,
        validator: function (value) {
          return ['focus', 'backlog'].indexOf(value) !== -1
        }
      }
    },
    data () {
      return {
        titleSearchFilter: {
          focus: '',
          backlog: ''
        },
        titleSearchFilterFocused: false,
        chaptersFilter: {
          focus: [],
          backlog: []
        },
        assigneeFilter: {
          focus: [],
          backlog: []
        },
        statusFilter: [],
        inputTimer: null,
        assignee: []
      }
    },
    methods: {
      getChapterBackground (chapter) {
        if (this.selectedHightCont === 1) {
          return 'url(' + chapter.image_high + ')'
        } else {
          return 'url(' + chapter.image + ')'
        }
      },
      setChaptersProgress () {
        let self = this
        setTimeout(function () {
          self.taskChapters.forEach(function (chapter) {
            let score = chapter.score
            let selector = '.tasks-filters .filters_progress_value-' + chapter.id
            self.setCompanyProgress(score, selector)
          })
        }, 1000)
      },
      setCompanyProgress (value, selector) {
        let RADIUS = 44
        let CIRCUMFERENCE = 2 * Math.PI * RADIUS
        let progressValue = document.querySelectorAll(selector)
        if (progressValue.length) {
          for (let i = 0; i < progressValue.length; i++) {
            let progress = value / 100
            if (progressValue[i]) {
              progressValue[i].style.opacity = 1
              progressValue[i].style.strokeDasharray = CIRCUMFERENCE
              progressValue[i].style.strokeDashoffset = CIRCUMFERENCE * (1 - progress)
            }
          }
        }
      },
      filterByChapter (chapter) {
        let chapterFilterExistsIndex = this.chaptersFilter[this.list].indexOf(chapter.id.toString())
        if (chapterFilterExistsIndex > -1) {
          this.chaptersFilter[this.list].splice(chapterFilterExistsIndex, 1)
        } else {
          this.chaptersFilter[this.list].push(chapter.id.toString())
        }
        if (this.chaptersFilter[this.list].length > 0) {
          if (this.list === 'focus') {
            this.$router.replace({
              hash: this.$route.hash,
              query: {
                ...this.$route.query,
                fc: encodeURIComponent(this.chaptersFilter[this.list].join(','))
              },
              params: { savePosition: true }
            })
          } else {
            this.$router.replace({
              hash: this.$route.hash,
              query: {
                ...this.$route.query,
                bc: encodeURIComponent(this.chaptersFilter[this.list].join(','))
              },
              params: { savePosition: true }
            })
          }
        } else {
          let query = Object.assign({}, this.$route.query)
          if (this.list === 'focus') {
            delete query.fc
          } else {
            delete query.bc
          }
          this.$router.replace({
            hash: this.$route.hash,
            query,
            params: { savePosition: true }
          })
        }
      },
      filterByAssignee (user) {
        if (user) {
          let userFilterExistsIndex = this.assigneeFilter[this.list].indexOf(user.value.toString())
          if (userFilterExistsIndex > -1) {
            this.assigneeFilter[this.list].splice(userFilterExistsIndex, 1)
          } else {
            this.assigneeFilter[this.list].push(user.value.toString())
          }
        } else {
          let userFilterExistsIndex = this.assigneeFilter[this.list].indexOf('unassigned')
          if (userFilterExistsIndex > -1) {
            this.assigneeFilter[this.list].splice(userFilterExistsIndex, 1)
          } else {
            this.assigneeFilter[this.list].push('unassigned')
          }
        }
        if (this.assigneeFilter[this.list].length > 0) {
          if (this.list === 'focus') {
            this.$router.replace({
              hash: this.$route.hash,
              query: {
                ...this.$route.query,
                fa: encodeURIComponent(this.assigneeFilter[this.list].join(','))
              },
              params: { savePosition: true }
            })
          } else {
            this.$router.replace({
              hash: this.$route.hash,
              query: {
                ...this.$route.query,
                ba: encodeURIComponent(this.assigneeFilter[this.list].join(','))
              },
              params: { savePosition: true }
            })
          }
        } else {
          let query = Object.assign({}, this.$route.query)
          if (this.list === 'focus') {
            delete query.fa
          } else {
            delete query.ba
          }
          this.$router.replace({
            hash: this.$route.hash,
            query,
            params: { savePosition: true }
          })
        }
      },
      filterByStatus (status) {
        let statusFilterExistsIndex = this.statusFilter.indexOf(status.id.toString())
        if (statusFilterExistsIndex > -1) {
          this.statusFilter.splice(statusFilterExistsIndex, 1)
        } else {
          this.statusFilter.push(status.id.toString())
        }
        if (this.statusFilter.length > 0) {
          this.$router.replace({
            hash: this.$route.hash,
            query: {
              ...this.$route.query,
              status: encodeURIComponent(this.statusFilter.join(','))
            },
            params: { savePosition: true }
          })
        } else {
          let query = Object.assign({}, this.$route.query)
          delete query.status
          this.$router.replace({
            hash: this.$route.hash,
            query,
            params: { savePosition: true }
          })
        }
      },
      isFilterActive (type, id) {
        if (type === 'chapter') {
          return this.chaptersFilter[this.list].indexOf(id.toString()) > -1
        } else if (type === 'assignee') {
          return this.assigneeFilter[this.list].indexOf(id.toString()) > -1
        } else if (type === 'status') {
          return this.statusFilter.indexOf(id.toString()) > -1
        }
        return false
      },
      activeFiltersCount (type) {
        if (type === 'chapter') {
          return this.chaptersFilter[this.list].length
        } else if (type === 'assignee') {
          return this.assigneeFilter[this.list].length
        } else if (type === 'status') {
          return this.statusFilter.length
        }
        return false
      },
      clearFilter (type) {
        let query = Object.assign({}, this.$route.query)
        if (type === 'chapter') {
          this.chaptersFilter[this.list] = []
          if (this.list === 'focus') {
            delete query.fc
          } else {
            delete query.bc
          }
        } else if (type === 'assignee') {
          this.assigneeFilter[this.list] = []
          if (this.list === 'focus') {
            delete query.fa
          } else {
            delete query.ba
          }
        } else if (type === 'status') {
          this.statusFilter = []
          delete query.status
        }
        this.$router.replace({
          hash: this.$route.hash,
          query,
          params: { savePosition: true }
        })
      },
      clearAllFilters () {
        let query = Object.assign({}, this.$route.query)
        this.titleSearchFilter[this.list] = ''
        this.chaptersFilter[this.list] = []
        this.assigneeFilter[this.list] = []
        this.statusFilter = []
        if (this.list === 'focus') {
          delete query.ft
          delete query.fc
          delete query.fa
        } else {
          delete query.bt
          delete query.bc
          delete query.ba
        }
        delete query.status
        this.$router.replace({
          hash: this.$route.hash,
          query,
          params: { savePosition: true }
        })
      },
      titleSearchInput (event) {
        if (this.inputTimer) {
          window.clearTimeout(this.inputTimer)
        }
        const self = this
        this.inputTimer = window.setTimeout(function () {
          self.titleSearchFilter[self.list] = event.target.value
        }, 400)
      }
    },
    created () {
      if (this.$route.query.ft && decodeURIComponent(this.$route.query.ft) !== '') {
        this.titleSearchFilter.focus = decodeURIComponent(this.$route.query.ft)
      }
      if (this.$route.query.bt && decodeURIComponent(this.$route.query.bt) !== '') {
        this.titleSearchFilter.backlog = decodeURIComponent(this.$route.query.bt)
      }
      if (this.$route.query.fc && decodeURIComponent(this.$route.query.fc) !== '') {
        this.chaptersFilter.focus = decodeURIComponent(this.$route.query.fc).split(',')
      }
      if (this.$route.query.bc && decodeURIComponent(this.$route.query.bc) !== '') {
        this.chaptersFilter.backlog = decodeURIComponent(this.$route.query.bc).split(',')
      }
      if (this.$route.query.fa && decodeURIComponent(this.$route.query.fa) !== '') {
        this.assigneeFilter.focus = decodeURIComponent(this.$route.query.fa).split(',')
      }
      if (this.$route.query.ba && decodeURIComponent(this.$route.query.ba) !== '') {
        this.assigneeFilter.backlog = decodeURIComponent(this.$route.query.ba).split(',')
      }
      if (this.$route.query.status && decodeURIComponent(this.$route.query.status) !== '') {
        this.statusFilter = decodeURIComponent(this.$route.query.status).split(',')
      }
    },
    computed: {
      ...mapGetters([
        'getUserRole',
        'selectedHightCont',
        'taskStatuses',
        'taskChapters',
        'taskAssignee'
      ]),
      anyFilters () {
        return this.chaptersFilter[this.list].length ||
          this.assigneeFilter[this.list].length ||
          (this.list === 'backlog' && this.statusFilter.length) ||
          this.titleSearchFilter[this.list] !== ''
      },
      imageBase () {
        return api.serverUserImages
      }
    },
    components: {
      Avatar
    },
    mounted () {
      this.setChaptersProgress()
    },
    watch: {
      'titleSearchFilter.focus' (value) {
        if (value && value !== '') {
          this.$router.replace({
            hash: this.$route.hash,
            query: {
              ...this.$route.query,
              ft: encodeURIComponent(value)
            },
            params: { savePosition: true }
          })
        } else {
          let query = Object.assign({}, this.$route.query)
          delete query.ft
          this.$router.replace({
            hash: this.$route.hash,
            query,
            params: { savePosition: true }
          })
        }
      },
      'titleSearchFilter.backlog' (value) {
        if (value && value !== '') {
          this.$router.replace({
            hash: this.$route.hash,
            query: {
              ...this.$route.query,
              bt: encodeURIComponent(value)
            },
            params: { savePosition: true }
          })
        } else {
          let query = Object.assign({}, this.$route.query)
          delete query.bt
          this.$router.replace({
            hash: this.$route.hash,
            query,
            params: { savePosition: true }
          })
        }
      },
      taskChapters (value) {
        if (value) {
          this.setChaptersProgress()
        }
      },
      company (value) {
        if (value) {
          this.setChaptersProgress()
        }
      }
    }
  }
</script>

<style src="@/assets/scss/components/tasks/tasks-filters.scss" lang="scss" scoped />



// WEBPACK FOOTER //
// TasksFilters.vue?7c26a077